import {Box} from '@mui/material';
import Grid from '@mui/material/Grid';

import {controlPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import MultipleAutocomplete from '../field-components/MultipleAutocomplete/MultipleAutocomplete';
import SwitchField from '../field-components/SwitchField/SwitchField';
import {practitionerSpecialtiesFields} from '../form-schemas/practitioner';

const SpecialtiesField = ({control}) => (
  <>
    <FieldLabel>Spécialités pratiquées au sein du cabinet :</FieldLabel>
    <Box sx={{p: 1.5, border: '1px solid #B3BDD2', borderRadius: 2}}>
      {' '}
      <Grid container>
        {' '}
        {practitionerSpecialtiesFields.map(s => (
          <Grid item xs={6} sm={2.4} key={s.name}>
            {' '}
            <SwitchField name={`specialties.${s.name}`} control={control} label={s.label} />{' '}
          </Grid>
        ))}{' '}
      </Grid>{' '}
      <Box mt={2}>
        {' '}
        <FieldLabel>Autres pratiques</FieldLabel>
        <MultipleAutocomplete name="specialties.other" control={control} placeholder="Ex : Ajouter une pratique" />
      </Box>{' '}
    </Box>{' '}
  </>
);

SpecialtiesField.propTypes = {
  control: controlPropType.isRequired
};

export default SpecialtiesField;
